<div class="wrapper flex align-items-center" [ngClass]="copiable ? 'justify-space-between' : 'justify-flex-start'">
  <div class="left-content flex align-items-center">
    <div class="avatar">
      <p-avatar
        [icon]="avatarIcon"
        shape="circle"
        styleClass="mr-2"
        size="large"
        [style]="{ 'background-color': '#EFF1FE', color: '#6E67ED' }"
      ></p-avatar>
    </div>
    <div class="information padding-left">
      <div class="information-value ellipsis">{{ informationData }}</div>
      <div class="title">{{ greyTitle }}</div>
    </div>
  </div>

  <!-- Only rendered if copiable is true -->
  <div *ngIf="copiable" class="copiable-container">
    <p-button
      icon="pi pi-copy"
      class="p-button-text copiable-button"
      (click)="handleCopy()"
      tooltip="Αντιγραφή"
      tooltipPosition="top"
    ></p-button>
  </div>
</div>
